<p>{{ message }}</p>

<div class="buttons-wrapper-right">
	<button type="button" (click)="closeDialog()">OK</button>
</div>
